// import { useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import FillableForm from "./FillableForm";
// import { addResponse } from "../../../store/formResponsesSlice";

// export default function FormPage() {
//   const { id } = useParams();
//   const formId = decodeURIComponent(id);
//   const forms = useSelector((state) => state.forms.completedForms);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const form = forms.find(
//     (f) => f.privateUrl === formId || f.id.toString() === formId
//   );

// console.log(forms)

//   const [formValues, setFormValues] = useState({});

//   if (!form) return <p className="p-10 text-red-500">Form not found</p>;

//   const handleSubmit = () => {
//     dispatch(addResponse({ formId: form.id, values: formValues }));
//     // navigate("/dashboard/supplier-registration");

//   };

//   return (
//     <div className="max-w-2xl mx-auto p-6  mt-24 mb-24">
//       <h1 className="text-2xl font-medium text-[#1D2739] py-6 text-left mt-2">
//         {form.title}
//       </h1>
//       {/* <h1 className="text-2xl font-semibold mb-4">{form.title}</h1> */}
//       <FillableForm
//         fields={form.fields}
//         onChange={setFormValues}
//         value={formValues}
//       />
//       <button
//         onClick={handleSubmit}
//         className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
//       >
//         Submit
//       </button>
//     </div>
//   );
// }




import MultiStepForm from "../../SupplierProfile/MultiStepForm";

export default function FormPage() {
  return (
    <div className="max-w-3xl mx-auto p-6 mt-24 mb-24">
      <MultiStepForm/>
    </div>
  );
}
